// auto-generated by {apiBaseUrl}/tools/typescriptmodels
import { TrackingModel } from "../base/tracking-model";

export class ClaimType extends TrackingModel {
	public ClaimTypeId: number = 0;
	public UID: string = "";
	public Description?: string;
}